const BASE = process.env.REACT_APP_NOTIFICATIONS_API_URL;

function getAuthHeaders() {
  const idToken = localStorage.getItem('id_token');
  return idToken
    ? { 'Content-Type': 'application/json', Authorization: `Bearer ${idToken}` }
    : { 'Content-Type': 'application/json' };
}

export async function fetchNotifications(projectId) {
  const res = await fetch(`${BASE}/notifications?projectId=${projectId}`, {
    headers: getAuthHeaders(),
  });
  if (!res.ok) throw new Error('Failed to fetch notifications');
  const data = await res.json();
  return data.notifications || [];
}

export async function createNotification({ projectId, type, title, message, jobId }) {
  const res = await fetch(`${BASE}/notifications`, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify({ projectId, type, title, message, jobId: jobId || null }),
  });
  if (!res.ok) throw new Error('Failed to create notification');
  const data = await res.json();
  return data.notification;
}

export async function updateNotification(notificationId, { projectId, type, title, message, status }) {
  const res = await fetch(`${BASE}/notifications/${notificationId}`, {
    method: 'PUT',
    headers: getAuthHeaders(),
    body: JSON.stringify({ projectId, type, title, message, status }),
  });
  if (!res.ok) throw new Error('Failed to update notification');
}

export async function deleteAllNotifications(projectId) {
  const res = await fetch(`${BASE}/notifications?projectId=${projectId}`, {
    method: 'DELETE',
    headers: getAuthHeaders(),
  });
  if (!res.ok) throw new Error('Failed to delete notifications');
}

export async function deleteNotification(notificationId, projectId) {
  const res = await fetch(`${BASE}/notifications/${notificationId}?projectId=${projectId}`, {
    method: 'DELETE',
    headers: getAuthHeaders(),
  });
  if (!res.ok) throw new Error('Failed to delete notification');
}